import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import Textarea from '../../components/react-validation/components/text-area';
// import { Modal } from '../../components/modal/modal';
import {Modal} from 'react-bootstrap';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import * as RegionMarketActionType from '../constants';
import {Dropdown} from 'components/Dropdown/Dropdown';
import Translate from '../../components/translate';

export class AddEditMarket extends Component {
  static propTypes = {
    selectListRegions: PropTypes.array,
    isOpenFormAddEdit: PropTypes.bool,
    errorMsg: PropTypes.array,
    isCreate: PropTypes.bool,
    item: PropTypes.object,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    title: PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = {
      selectListRegions: props.selectListRegions,
      selectedRegion: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.form) {
      this.form.resetForm(this.refs);
      if (nextProps.errorMsg.length) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
      } else {
        this.setState({selectedRegion: {}});
      }
    }

    if (nextProps.item && !isEmpty(nextProps.item.id)) {
      this.setState({
        selectListRegions: nextProps.selectListRegions,
        selectedRegion: {
          extensionValue: null,
          selected: false,
          text: nextProps.item.regionName,
          value: nextProps.item.regionId
        }
      });
    }

  }

  onChangeRegion = event => {
    this.setState({selectedRegion: event.value});
  }

  mapParam() {
    let param = this.form.getValues();
    param['regionId'] = this.state.selectedRegion.value;
    return param;
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.props.isCreate) {
      this.props.onSubmit(e,
        this.mapParam(),
        RegionMarketActionType.CREATE_MARKET_ASYNC);
    } else {
      this.props.onSubmit(e,
        this.mapParam(),
        RegionMarketActionType.UPDATE_MARKET_ASYNC);
    }

  }

  render() {
    const title = <span>{this.props.title} <Translate translateKey='market' capitalize /></span>;
    const regionPlaceholder = <span>Select a <Translate translateKey='region' capitalize /></span>;
    return <Modal show={this.props.isOpenFormAddEdit}>
      <div className='modal-header'>
        <button type='button' className='close' onClick={this.props.onCloseModal}>&times;</button>
        <h4 className='modal-title'>{title}</h4>
      </div>
      <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
        <div className='modal-body'>
          <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
          <div className='form-group'>
            <label><Translate translateKey='region' capitalize /> <span className='text-danger'>*</span></label>
            <Dropdown
              onChange={this.onChangeRegion}
              className='filestring-dropdown filter-dropdown'
              value={this.state.selectedRegion}
              options={this.props.selectListRegions}
              optionLabel='text'
              placeholder={regionPlaceholder}
              errorMessage='This information is required.'
              style={{width: '100%'}}
              ref={ref => {
                this.regionDropdown = ref;
              }}
            />

          </div>
          <div className='form-group'>
            <label><Translate translateKey='market' capitalize /> name <span className='text-danger'>*</span></label>
            <Input type='text'
              name='name'
              ref='name'
              value={this.props.item.name}
              placeholder='Market name'
              className='form-control'
              autoFocus
              max='40'
              maxLength='40'
              validations={[Vali.required, Vali.maxlength]} />
          </div >
          <div className='form-group'>
            <label>Description </label>
            <Textarea
              name='description'
              ref='description'
              value={this.props.item.description}
              placeholder='Description'
              className='form-control'
              max='200'
              maxLength='200'
              validations={[Vali.maxlength]} />
          </div >
        </div>
        <div className='modal-footer'>
          <Submit className='btn btn-primary btn-siteone'>Done</Submit>
        </div>
      </Form>
    </Modal>;
  }
}




// WEBPACK FOOTER //
// ./src/Region-Market/Containers/add-edit-market.js